// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminProducts_emptyState__xL4Ax {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  padding: 2rem;
}
.AdminProducts_emptyState__icon__5kWVW {
  width: 26rem;
  min-width: 26rem;
  height: auto;
  flex-shrink: 0;
  margin-bottom: 2.4rem;
}
.AdminProducts_emptyState__title__9295Y {
  font-size: 2rem;
  font-weight: 700;
  max-width: 768px;
  margin-bottom: 0.4rem;
}
.AdminProducts_emptyState__subText__B5mC9 {
  font-size: 1.4rem;
}
.AdminProducts_emptyState__action__WHI4\\+ {
  margin-top: 2.4rem;
}

.AdminProducts_product__uXpyW {
  border: 1px solid var(--color-grey-2);
  border-radius: 1.6rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 1.2rem;
  padding-bottom: 1.6rem;
}
.AdminProducts_product__uXpyW img {
  width: 100%;
  aspect-ratio: 4/3;
  object-fit: cover;
  border-radius: 1.6rem 1.6rem 0 0;
  border-bottom: 1px solid var(--color-grey-2);
}
.AdminProducts_product__uXpyW > :not(:first-child) {
  padding: 0 1.6rem;
}
.AdminProducts_product__actions__3Qpd8 {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.AdminProducts_product__grid__I6S83 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 1024px) {
  .AdminProducts_product__grid__I6S83 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.AdminProducts_singleProduct__7VzZ8 {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin-top: 2rem;
}
.AdminProducts_singleProduct__top__0mtxT {
  width: 100%;
  max-width: 144rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.AdminProducts_singleProduct__top__details__Y4x5H {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  min-width: 0;
}
@media only screen and (max-width: 768px) {
  .AdminProducts_singleProduct__top__0mtxT {
    grid-template-columns: 1fr;
  }
}
.AdminProducts_singleProduct__images__I4pMJ {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.AdminProducts_singleProduct__mainImage__Cxb7t {
  border-radius: 1.2rem;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.AdminProducts_singleProduct__mainImage__Cxb7t img {
  width: 100%;
  display: block;
  border-radius: 1.2rem;
}
.AdminProducts_singleProduct__imageArrow__1an9u {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 3.6rem;
  height: 3.6rem;
  border: none;
  border-radius: 50%;
  display: grid;
  place-items: center;
  cursor: pointer;
  background: var(--color-fash-black);
  color: var(--color-white);
  z-index: 2;
  font-size: 2rem;
}
.AdminProducts_singleProduct__imageArrow__1an9u:hover {
  background: var(--color-fash-primary);
  color: var(--color-fash-black);
}
.AdminProducts_singleProduct__imageArrowLeft__l\\+95P {
  left: 1rem;
}
.AdminProducts_singleProduct__imageArrowRight__v9IpR {
  right: 1rem;
}
.AdminProducts_singleProduct__otherImages__gaMw4 {
  display: flex;
  gap: 1.2rem;
  align-items: center;
  flex-wrap: wrap;
}
.AdminProducts_singleProduct__otherImages__gaMw4 img {
  width: 15rem;
  border-radius: 1.2rem;
  cursor: pointer;
}
.AdminProducts_singleProduct__selectedImage__LULag {
  border: 1px solid var(--color-fash-black);
}
.AdminProducts_singleProduct__prices__RO160 {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  white-space: nowrap;
}
.AdminProducts_singleProduct__bottom__oS-XR {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Admin/AdminProducts.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AACD;AACC;EACC,YAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AACF;AAEC;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAAF;AAGC;EACC,iBAAA;AADF;AAIC;EACC,kBAAA;AAFF;;AAMA;EACC,qCAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAHD;AAKC;EACC,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;EACA,4CAAA;AAHF;AAMC;EACC,iBAAA;AAJF;AAOC;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AALF;AAQC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AANF;AAQE;EALD;IAME,qCAAA;EALD;AACF;;AASA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAND;AAQC;EACC,WAAA;EACA,iBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AANF;AAQE;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AANH;AASE;EAdD;IAeE,0BAAA;EAND;AACF;AASC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAPF;AAUC;EACC,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AARF;AAUE;EACC,WAAA;EACA,cAAA;EACA,qBAAA;AARH;AAYC;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;AAVF;AAYE;EACC,qCAAA;EACA,8BAAA;AAVH;AAcC;EACC,UAAA;AAZF;AAeC;EACC,WAAA;AAbF;AAgBC;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAdF;AAgBE;EACC,YAAA;EACA,qBAAA;EACA,eAAA;AAdH;AAkBC;EACC,yCAAA;AAhBF;AAmBC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAjBF;AAoBC;EACC,WAAA;AAlBF","sourcesContent":[".emptyState {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 100%;\n\ttext-align: center;\n\tpadding: 2rem;\n\n\t&__icon {\n\t\twidth: 26rem;\n\t\tmin-width: 26rem;\n\t\theight: auto;\n\t\tflex-shrink: 0;\n\t\tmargin-bottom: 2.4rem;\n\t}\n\n\t&__title {\n\t\tfont-size: 2rem;\n\t\tfont-weight: 700;\n\t\tmax-width: 768px;\n\t\tmargin-bottom: 0.4rem;\n\t}\n\n\t&__subText {\n\t\tfont-size: 1.4rem;\n\t}\n\n\t&__action {\n\t\tmargin-top: 2.4rem;\n\t}\n}\n\n.product {\n\tborder: 1px solid var(--color-grey-2);\n\tborder-radius: 1.6rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tgap: 1.2rem;\n\tpadding-bottom: 1.6rem;\n\n\timg {\n\t\twidth: 100%;\n\t\taspect-ratio: 4 / 3; // keeps height consistent\n\t\tobject-fit: cover;\n\t\tborder-radius: 1.6rem 1.6rem 0 0;\n\t\tborder-bottom: 1px solid var(--color-grey-2);\n\t}\n\n\t& > :not(:first-child) {\n\t\tpadding: 0 1.6rem;\n\t}\n\n\t&__actions {\n\t\tmargin-top: auto;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 0.8rem;\n\t}\n\n\t&__grid {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: 1024px) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t}\n}\n\n.singleProduct {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4rem;\n\tmargin-top: 2rem;\n\n\t&__top {\n\t\twidth: 100%;\n\t\tmax-width: 144rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t\tgap: 2rem;\n\n\t\t&__details {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 1.2rem;\n\t\t\tmin-width: 0; // prevents grid cell from expanding past its track, enabling overflow-x: auto on children\n\t\t}\n\n\t\t@media only screen and (max-width: 768px) {\n\t\t\tgrid-template-columns: 1fr;\n\t\t}\n\t}\n\n\t&__images {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1.2rem;\n\t}\n\n\t&__mainImage {\n\t\tborder-radius: 1.2rem;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\toverflow: hidden;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\tdisplay: block;\n\t\t\tborder-radius: 1.2rem;\n\t\t}\n\t}\n\n\t&__imageArrow {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\twidth: 3.6rem;\n\t\theight: 3.6rem;\n\t\tborder: none;\n\t\tborder-radius: 50%;\n\t\tdisplay: grid;\n\t\tplace-items: center;\n\t\tcursor: pointer;\n\t\tbackground: var(--color-fash-black);\n\t\tcolor: var(--color-white);\n\t\tz-index: 2;\n\t\tfont-size: 2rem;\n\n\t\t&:hover {\n\t\t\tbackground: var(--color-fash-primary);\n\t\t\tcolor: var(--color-fash-black);\n\t\t}\n\t}\n\n\t&__imageArrowLeft {\n\t\tleft: 1rem;\n\t}\n\n\t&__imageArrowRight {\n\t\tright: 1rem;\n\t}\n\n\t&__otherImages {\n\t\tdisplay: flex;\n\t\tgap: 1.2rem;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\n\t\timg {\n\t\t\twidth: 15rem;\n\t\t\tborder-radius: 1.2rem;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t&__selectedImage {\n\t\tborder: 1px solid var(--color-fash-black);\n\t}\n\n\t&__prices {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1.2rem;\n\t\twhite-space: nowrap;\n\t}\n\n\t&__bottom {\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `AdminProducts_emptyState__xL4Ax`,
	"emptyState__icon": `AdminProducts_emptyState__icon__5kWVW`,
	"emptyState__title": `AdminProducts_emptyState__title__9295Y`,
	"emptyState__subText": `AdminProducts_emptyState__subText__B5mC9`,
	"emptyState__action": `AdminProducts_emptyState__action__WHI4+`,
	"product": `AdminProducts_product__uXpyW`,
	"product__actions": `AdminProducts_product__actions__3Qpd8`,
	"product__grid": `AdminProducts_product__grid__I6S83`,
	"singleProduct": `AdminProducts_singleProduct__7VzZ8`,
	"singleProduct__top": `AdminProducts_singleProduct__top__0mtxT`,
	"singleProduct__top__details": `AdminProducts_singleProduct__top__details__Y4x5H`,
	"singleProduct__images": `AdminProducts_singleProduct__images__I4pMJ`,
	"singleProduct__mainImage": `AdminProducts_singleProduct__mainImage__Cxb7t`,
	"singleProduct__imageArrow": `AdminProducts_singleProduct__imageArrow__1an9u`,
	"singleProduct__imageArrowLeft": `AdminProducts_singleProduct__imageArrowLeft__l+95P`,
	"singleProduct__imageArrowRight": `AdminProducts_singleProduct__imageArrowRight__v9IpR`,
	"singleProduct__otherImages": `AdminProducts_singleProduct__otherImages__gaMw4`,
	"singleProduct__selectedImage": `AdminProducts_singleProduct__selectedImage__LULag`,
	"singleProduct__prices": `AdminProducts_singleProduct__prices__RO160`,
	"singleProduct__bottom": `AdminProducts_singleProduct__bottom__oS-XR`
};
export default ___CSS_LOADER_EXPORT___;
